import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import { UserLoggedModule } from "@/apps/2#userLogged/store";
import { SharedModule } from "@/apps/shared/store";
import { AuthModule } from "@/apps/2#auth/store";
import Permissao from "./apps/1#Permissoes/meta";
import Funcionario from "./apps/9#Funcionarios/meta";
import Produto from "./apps/41#Produtos/meta";
import Caixa from "./apps/27#Caixas/meta";
import Cliente from "@/apps/44#Clientes/meta";
import Fornecedor from "@/apps/Fornecedor/meta";
import GestorDePedido from "@/apps/GestorDePedido/meta";
import Lojas from "./apps/0#Lojas/meta";
import Insumos from "./apps/Insumos/meta";
import SignedTransaction from "./apps/SignedTransaction/meta";
import Report from "./apps/Relatorio/meta";
import Estoque from "./apps/20#Estoques/meta";
import Invoices from "./apps/46#Invoices/meta";
import Checkout from "./apps/Checkout/meta";
import MySubscription from "./apps/MySubscription/meta";
import CustomKey from "./apps/CosmosPluginStore/meta";
import ExternalMovimentation from "./apps/ExternalMovimentation/meta";
import Unidades from "./apps/Unidades/meta";
import Veiculos from "./apps/Veiculos/meta";
import ContatosEmpresa from "./apps/ContatosEmpresa/meta";
import Obras from "./apps/Obras/meta";
import AdminOnboarding from "./apps/AdminOnboarding/meta";
import Entregas from "./apps/Entregas/meta";

export const store = new Vuex.Store({
  modules: {
    UserLoggedModule,
    AuthModule,
    SharedModule,
    permissao_module: Permissao.module,
    funcionarios_module: Funcionario.module,
    caixas_module: Caixa.module,
    produto: Produto.module,
    cliente: Cliente.module,
    mod_forn: Fornecedor.module,
    mod_gestor: GestorDePedido.module,
    mod_loja: Lojas.module,
    mod_insumos: Insumos.module,
    mod_transac: SignedTransaction.module,
    mod_estoque: Estoque.module,
    mod_invoice: Invoices.module,
    mod_checkout: Checkout.module,
    mod_subscription: MySubscription.module,
    mod_reports: Report.module,
    custom_key: CustomKey.module,
    mod_external_movimentation: ExternalMovimentation.module,
    mod_unidades: Unidades.module,
    mod_veiculos: Veiculos.module,
    mod_contatos_empresa: ContatosEmpresa.module,
    mod_obras: Obras.module,
    mod_entregas: Entregas.module,
    AdminOnboarding: AdminOnboarding.module
  }
});

export default store;
